// extracted by mini-css-extract-plugin
var _1 = "pfx-UnorderedList-module__container--c4XkP";
export { _1 as "container" }
